import React, { useState, useEffect } from 'react';
import { Card, CardContent, Typography, Button, Box, CircularProgress } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import GoogleIcon from '@mui/icons-material/Google';
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import { useDispatch, useSelector } from 'react-redux';
import { getGoogleBusinessStatusStore, postGoogleCallbackStore, deleteGoogleBusinessStore } from '../../../../store/ratings/thunks';
import { ModalConfirmDeactivation } from '../../../../components/modals/ModalConfirmDeactivation';
import { useResponseHandler } from '../../../../hooks/useResponseHandler';

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const ConfiguracionContent = () => {
  const dispatch = useDispatch<any>();
  const { googleBusinessData } = useSelector((state: any) => state.ratingsDevices);

  const { handleResponse, ResponseComponents, setMsgSnack, setAlertSnack } = useResponseHandler();

  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  console.log('googleBusinessData ',googleBusinessData)
  useEffect(() => {
    fetchStatus();
  }, []);

  const fetchStatus = async () => {
    const response = await dispatch(getGoogleBusinessStatusStore());
    await handleResponse(response, '', false);
  };

  const login = useGoogleLogin({
    flow: 'auth-code',
    scope: 'https://www.googleapis.com/auth/business.manage',
    onSuccess: async (codeResponse: any) => {
      try {
        const response = await dispatch(postGoogleCallbackStore(codeResponse.code));
        await handleResponse(response, 'Google Business conectado', true);
        if (response?.ok) {
          await fetchStatus();
        }
      } catch (error) {
        await setMsgSnack({ msg: 'Ocurrió un error inesperado', status: 'error' });
        await setAlertSnack(true);
      }
    },
    onError: async (errorResponse:any) => {
      console.error(errorResponse);
      await setMsgSnack({ msg: 'Error en la autenticación con Google', status: 'error' });
      await setAlertSnack(true);
    },
  });

  const handleConnect = () => {
    login();
  };

  const confirmDisconnect = async () => {
    if (!googleBusinessData?.id) return;
 
    const response = await dispatch(deleteGoogleBusinessStore(googleBusinessData.id));
    await handleResponse(response, 'Cuenta desconectada', true);
    if (response?.ok) {
      await fetchStatus();
    }
  };

  // if (loading) {
  //   return (
  //     <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '60vh' }}>
  //       <CircularProgress />
  //     </Box>
  //   );
  // }

  // Datos reales del objeto de configuración o valores por defecto
  const emailDisplay = googleBusinessData?.email || 'Sin correo vinculado'; 
  const locationDisplay = googleBusinessData?.locationName || 'Ubicación no configurada';
  const displayId = googleBusinessData?.maskedId || 'ID no disponible';

  return (
    <Box sx={{ p: 3, maxWidth: 800, margin: '0 auto' }}>
      {ResponseComponents}
      <Typography variant="h4" sx={{ mb: 4, fontWeight: 'bold', color: '#333' }}>
        Configuración de Google Business
      </Typography>

      {googleBusinessData && Object.keys(googleBusinessData).length > 0 ? (
        <Card sx={{ boxShadow: 4, borderRadius: 3, borderTop: '4px solid #4285F4' }}>
          <CardContent sx={{ p: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
              <GoogleIcon sx={{ color: '#4285F4', fontSize: 36, mr: 1.5 }} />
              <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                Detalles de Integración
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, width: 200, color: 'text.secondary' }}>
                  Estado:
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: '#e8f5e9', px: 2, py: 0.5, borderRadius: 2 }}>
                  <CheckCircleIcon sx={{ color: '#2e7d32', mr: 1, fontSize: 20 }} />
                  <Typography variant="body1" sx={{ color: '#2e7d32', fontWeight: 600 }}>
                    Conectado correctamente
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, width: 200, color: 'text.secondary' }}>
                  Cuenta vinculada:
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {emailDisplay}
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, width: 200, color: 'text.secondary' }}>
                  Nombre Ubicacion:
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {locationDisplay}
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, width: 200, color: 'text.secondary' }}>
                  ID de Conexión:
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500, fontFamily: 'monospace', bgcolor: '#f5f5f5', px: 1, borderRadius: 1 }}>
                  {displayId}
                </Typography>
              </Box>

              <Box sx={{ mt: 3, pt: 3, borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => setOpenConfirmModal(true)}
                >
                  Desconectar Cuenta
                </Button>
              </Box>

            </Box>
          </CardContent>
        </Card>
      ) : (
        <Card sx={{ boxShadow: 4, borderRadius: 3, textAlign: 'center', p: 4, bgcolor: '#f8f9fa' }}>
          <CardContent>
            <Box sx={{ display: 'inline-flex', p: 3, borderRadius: '50%', bgcolor: '#e8f0fe', mb: 3 }}>
              <GoogleIcon sx={{ color: '#4285F4', fontSize: 64 }} />
            </Box>
            <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
              Integra tu cuenta de Google Business
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 600, mx: 'auto', lineHeight: 1.6 }}>
              Conecta tu cuenta oficial de Google Business para sincronizar y gestionar tus reseñas. 
              Podrás interactuar con tus clientes y analizar el rendimiento de tu reputación online directamente desde nuestra plataforma. 
              Gana visibilidad y mejora tu posicionamiento conectándote de forma segura.
            </Typography>
            <Button
              variant="contained"
              size="large"
              onClick={handleConnect}
              startIcon={<GoogleIcon />}
              sx={{
                bgcolor: '#4285F4',
                color: 'white',
                fontWeight: 'bold',
                px: 4,
                py: 1.5,
                textTransform: 'none',
                borderRadius: 2,
                fontSize: '1rem',
                boxShadow: '0 4px 6px rgba(66, 133, 244, 0.3)',
                '&:hover': {
                  bgcolor: '#357ae8',
                  boxShadow: '0 6px 8px rgba(66, 133, 244, 0.4)',
                },
              }}
            >
              Conectar con Google Business
            </Button>
          </CardContent>
        </Card>
      )}

      <ModalConfirmDeactivation
        open={openConfirmModal}
        setOpen={setOpenConfirmModal}
        onConfirm={confirmDisconnect}
        title="Desconectar Cuenta"
        description="¿Estás seguro de que deseas desconectar tu cuenta de Google Business? Dejarás de recibir actualizaciones y reseñas."
      />
    </Box>
  );
};

export const Configuracion = () => (
  <GoogleOAuthProvider clientId={CLIENT_ID}>
    <ConfiguracionContent />
  </GoogleOAuthProvider>
);
